import { getLogger } from '@molecule/app-logger'

import { setupAppAiChatHttp } from './app-ai-chat-http.js'
import { setupAppAiVoice } from './app-ai-voice.js'
import { setupAppCodeEditorMonaco } from './app-code-editor-monaco.js'
import { setupAppCountryFlags } from './app-country-flags.js'
import { setupAppIdeDefault } from './app-ide-default.js'
import { setupAppLivePreviewIframe } from './app-live-preview-iframe.js'
import { setupAppIdeLocales } from './app-locales-ide.js'

let initialized = false

/**
 * Wire the IDE-only bonds: chat, code editor, workspace, and live preview.
 *
 * These pull in heavy provider implementations (the Monaco editor wrapper, the
 * HTTP chat provider, etc.) that the landing page and other public routes never
 * use. They are deliberately kept OUT of {@link setupProviders} and this module
 * is imported only from the lazy Workspace route chunk (`WorkspaceRoute.tsx`),
 * so the bundler code-splits these providers out of the entry bundle — the
 * landing page downloads only React, the router, i18n, and the landing UI.
 *
 * Idempotent: safe to call on every Workspace mount.
 */
export function setupIdeProviders(): void {
  if (initialized) return
  initialized = true
  void setupAppIdeLocales().catch((error) => {
    getLogger('ide-locales').warn('Unable to load IDE translations', { error })
  })
  setupAppAiChatHttp()
  // On-device dictation fallback (Parakeet/Whisper by language) — the model
  // and runtime load lazily on first mic use, so wiring here costs nothing.
  setupAppAiVoice()
  setupAppCodeEditorMonaco()
  // Region flags for the model picker — IDE-only, so the inlined flag SVGs
  // stay out of the landing/entry bundle.
  setupAppCountryFlags()
  setupAppIdeDefault()
  setupAppLivePreviewIframe()
}
